import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { Order } from '../../Shared/interfaces/order.interface';
import { SkeletonModule } from 'primeng/skeleton';
import { SharedService } from '../../Shared/services/shared.service';
import { ApiResponce } from '../../Shared/interfaces/apiResponce.interface';
import { KitcheOrder } from '../../Shared/interfaces/kitchen-orders';
import { InvoicesComponent } from '../../invoices/invoices.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TooltipModule } from 'primeng/tooltip';
import { AutoReloadService } from '../../Shared/services/auto-reload.service';

@Component({
  selector: 'app-pending-orders',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    SkeletonModule,
    InvoicesComponent,
    ConfirmDialogModule,
    TooltipModule,
  ],
  providers: [DatePipe],
  templateUrl: './pending-orders.component.html',
  styleUrl: './pending-orders.component.scss',
})
export class PendingOrdersComponent implements OnInit {
  @Input('pendingOrderList') pendingOrderList!: Order[];
  @Input('loader') loader!: boolean;
  @Output() closePanelEvent = new EventEmitter<boolean>();
  // @Output() statusChanged = new EventEmitter<boolean>();
  @Output() stopAudio = new EventEmitter<boolean>(false);

  rejectStatus: boolean = false;
  acceptStatus: boolean = false;
  acceptAndPrint: boolean = false;
  user_data: any;

  singleOrderDetail: any;
  showPrintPage: boolean = false;
  selectedInvoice: { id: number; name: string }[] = [
    { id: 1, name: 'Kitchen' },
  ];
  loadingItemId!: number;
  dateTime: string | null = '';

  constructor(private sharedS: SharedService, private datePipe: DatePipe, private reloadService: AutoReloadService,private cd:ChangeDetectorRef) {}

  ngOnInit(): void {
    // console.log("Pending List");
    this.getLocalStorage();
  }

  getLocalStorage() {
    this.sharedS.getData().subscribe((val: any) => {
      this.user_data = val.user;
    });
  }

  close() {
    this.closePanelEvent.emit(false);
  }

  getSingleOrderDetail(orderId: number) {
    this.sharedS
      .sendGetRequest(`get_order_by_id?order_id=${orderId}`)
      .subscribe({
        next: (res: ApiResponce) => {
          if (res.Success) {
            this.acceptStatus = false;
            this.rejectStatus = false;
            if (res.Data.order_details.length > 0) {
              // Then Print Invoices..
              this.printInvoice(res.Data, this.selectedInvoice,orderId);


            }
          } else {
          }
        },
        error: (err: any) => {
          this.acceptStatus = false;
          this.rejectStatus = false;
        },
      });
  }
  changeOrderStatusAPI(order: any, status: number, isPrinted?: boolean) {
    
    this.loadingItemId = order.id;
    if (status === 3 && !isPrinted) {
      this.acceptStatus = true;
    } else if (isPrinted == true && status === 3) {
      this.acceptAndPrint = true;
    } else if (status === 8) {
      this.rejectStatus = true;
    }
    let payload = { order_id: order.id, status_id: status };
    this.sharedS.sendPostRequest('update_order_status', payload).subscribe({
      next: (res: ApiResponce) => {
        if (res.Success &&res.Data) {
          if (isPrinted) {
            // Then Print Invoices..
            this.showPrintPage=false;
            this.getSingleOrderDetail(order.id);
            this.reloadService.addOrderToFilteredData(res.Data)

          } else {
            this.acceptStatus = false;
            this.rejectStatus = false;
            this.acceptAndPrint = false;
            this.reloadService.addOrderToFilteredData(res.Data)
            this.modifyPendingListAry(order.id); 
          }
          this.loadingItemId =0
        } else {
          this.loadingItemId =0

          // console.error('res:', res);
        }
      },
      error: (err: any) => {
        this.acceptStatus = false;
        this.rejectStatus = false;
        this.acceptAndPrint = false;
        this.loadingItemId =0
      },
    });
  }

  checkInvoice(order: any, invoice: { id: number; name: string }) {
    const existingIndex = this.selectedInvoice.findIndex(
      (inv) => inv.id === invoice.id
    );
    if (existingIndex > -1) {
      this.selectedInvoice.splice(existingIndex, 1);
    } else {
      this.selectedInvoice.push(invoice);
    }
    console.log(this.selectedInvoice);
  }

  checkIfInvoiceSelected(
    order: any,
    invoice: { id: number; name: string },
    id?: any
  ) {
    let check = false;
    if (order.id === id) {
      check = this.selectedInvoice.some((inv) => inv.id === invoice.id);
    }
    return check;
  }

  printInvoice(order: any, invoiceType: { id: number; name: string }[],order_id:any) {
    this.singleOrderDetail = order;
    this.selectedInvoice = invoiceType;
      this.showPrintPage = true;
      this.modifyPendingListAry(order_id);

  }

  modifyPendingListAry(order_id: number) {
    let index = this.pendingOrderList.findIndex((item) => item.id ==order_id);
    this.pendingOrderList.splice(index, 1);
    if (this.pendingOrderList.length === 0) {
      this.stopAudio.emit(true);
      setTimeout(() => this.closePanelEvent.emit(false), 2000); 
  }
  }

  convertToLocalTimeZone(dateTimeString: any, date: boolean) {
    let retDate: any = new Date(`${dateTimeString} UTC`);
    this.dateTime = this.datePipe.transform(
      retDate,
      date ? 'h:mm a' : 'MM-dd-yyyy',
      '+05:00'
    );
    return this.dateTime;
  }
}
